var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-761.000000, -2675.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Announcement",
    transform: "translate(761.000000, 2675.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,19.7999998 C21,20.1457497 20.7234375,21 19.75,21 C19.4660872,21.0002126 19.1905568,20.9076344 18.96875,20.7374997 L15.6484375,18.1874999 C14.3069113,17.1607119 12.7003974,16.5024679 11,16.2828751 L11,7.71900097 C12.7003765,7.49933523 14.3068709,6.84109921 15.6484375,5.81437616 L18.96875,3.26250141 C19.1904495,3.09218057 19.4660502,2.99957874 19.75,3 C20.7265625,3 21,3.87225135 21,4.20000132 L21,19.7999998 Z",
    id: "Path",
    fill: "#E7E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7777007,10.07375 L21.7777007,14.0929167 C22.5334927,13.6810482 23,12.9140631 23,12.0833333 C23,11.2526035 22.5334927,10.4856185 21.7777007,10.07375 Z M1,10.3333333 L1,13.8333333 C1,15.1219977 2.094411,16.1666667 3.44443538,16.1666667 L4.73158339,16.1666667 C4.67694255,16.5533808 4.64912745,16.9431185 4.64831981,17.3333333 C4.64802518,18.7348036 4.98187061,20.117959 5.62456619,21.3780208 C5.82279462,21.7677604 6.25553607,22 6.70928439,22 L9.5463572,22 C10.5413188,22 11.1386777,20.9120833 10.5355896,20.1566667 C9.88671852,19.3458738 9.53570448,18.3536346 9.53680863,17.3333333 C9.53807648,16.9390064 9.59472679,16.5466218 9.7052455,16.1666667 L10.7777415,16.1666667 L10.7777415,8 L3.44443538,8 C2.094411,8 1,9.04466892 1,10.3333333 Z",
    id: "Shape",
    fill: "#C2C0CC"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncement);
export default __webpack_public_path__ + "static/media/iconAnnouncement.83424cb0.svg";
export { ForwardRef as ReactComponent };